<div class="card">
    <div class="card-header d-flex flex-column" style="gap: 1rem;">
        <div style="font-family: 'Lato';" *ngIf="title != '' || description != ''"
            class="m-1 d-flex align-items-baseline justify-content-start flex-column flex-sm-column text-left flex-wrap">
            <h2 style="color:#404b5a" *ngIf="title != ''" class="m-0 mr-2">{{title | slice:0:100 | uppercase}}</h2>
            <small *ngIf="description != ''" class="title-description" style="max-width: 600px;">{{description |
                slice:0:200}}</small>
        </div>
        <mat-form-field appearance="fill" class="w-100">
            <mat-label style="font-family: 'Lato';">Buscar</mat-label>
            <input style="font-family: 'Lato';" matInput type="text" placeholder="Buscar" (keyup)="applyFilter($event)"
                #input>
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        <div class="checkbox-section">
            <mat-checkbox class="checkbox-margin" [(ngModel)]="showFieldInactive"
                (ngModelChange)="showInactive($event)">Mostrar inactivos</mat-checkbox>
            <mat-checkbox class="checkbox-margin" [(ngModel)]="showFieldAudit" (ngModelChange)="showAudit($event)">
                Mostrar campos de auditoria</mat-checkbox>
            <mat-form-field appearance="fill">
                <mat-label>Tienda</mat-label>
                <input matInput [matAutocomplete]="autoTienda" [(ngModel)]="ctrlTiendas" (keyup)="storeFilter($event)"
                    (blur)="changeStore()">
                <mat-autocomplete #autoTienda="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let tienda of storesFiltered" [value]="tienda">
                        {{tienda['C_AGE']}} - {{tienda['NOM']}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <button mat-fab matTooltip="Nuevo encabezado" class="fab" (click)="dialogAdd()">
                <mat-icon>add</mat-icon>
            </button>
        </div>


    </div>

    <div style="font-family: 'Lato';" class="card-body text-center" *ngIf="data.length==0">
        No hay registros que mostrar
    </div>

    <div class="card-body overflow-auto p-0 ">
        <div class="table-container">
            <table mat-table *ngIf="data.length>0" [dataSource]="dataSource" class="mat-elevation-z8">
                <!-- *ngIf="item.name != 'actions' && item.name != 'documento' && item.name != 'nombre'
                && item.name != 'tienda' && item.name != 'SAP/EMAIL' && item.name != 'Creacion/modificacion' && item.name!='incluye'" -->
                <!-- 
                [ngClass]="{'text-break': render(item, element).length>40,
                        'text-wrap':render(item, element).length>20, 'text-nowrap':render(item, element).length<=20}" -->

                <ng-container matColumnDef="{{item.name}}" *ngFor="let item of columns">
                    <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">{{item.title|uppercase}}</th>
                    <div
                        *ngIf="item.name.toUpperCase() != 'ACTIONS' && item.name.toUpperCase() != 'EST' && item.name.toUpperCase() != 'CODIGO_SAP' && item.name.toUpperCase() != 'CREACION' && item.name.toUpperCase() != 'MODIFICACION' ">
                        <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3">
                            <!-- <span class="mobile-label mr-2">{{item.title|uppercase}}:</span> -->
                            <!-- {{item.name.toUpperCase()}} -->
                            {{render(item, element)}}
                        </td>
                    </div>
                    <div
                        *ngIf="item.name.toUpperCase() == 'CODIGO_SAP' || item.name.toUpperCase() == 'CREACION' || item.name.toUpperCase() == 'MODIFICACION'">
                        <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3">
                            <div [innerHTML]="render(item, element)">

                            </div>
                        </td>
                    </div>
                    <div *ngIf="item.name.toUpperCase() == 'EST'">
                        <td mat-cell *matCellDef="let element" [ngClass]="{'text-break': render(item, element).length>40,
                        'text-wrap':render(item, element).length>20, 'text-nowrap':render(item, element).length<=20,
                        'td-align-center': item.name.toUpperCase() == 'EST'}" class="p-1 pr-3 pl-3">
                            <!-- <span class="mobile-label mr-2">{{item.title|uppercase}}:</span>
                        {{render(item, element)}} -->
                            <button mat-flat-button (click)="changeState(element)"
                                [ngClass]="element.EST=='A' ? 'btn done' : element.EST=='I' ? 'btn inactive': 'btn done'"
                                type="button">{{element.EST=='A' ? "Activo" : element.EST=='I' ? "Inactivo" :
                                "Activo"}}</button>
                        </td>
                    </div>
                    <div *ngIf="item.name.toUpperCase() == 'ACTIONS'">
                        <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3 td-align-center">
                            <button mat-icon-button matTooltip="Editar" (click)="dialogModify(element)">
                                <mat-icon>create</mat-icon>
                            </button>
                            <button mat-icon-button matTooltip="Agregar tiendas" (click)="dialogStores(element)">
                                <mat-icon>store</mat-icon>
                            </button>
                        </td>
                    </div>






                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                    [class.demo-row-is-clicked]="selected.has(row)"></tr>
            </table>

        </div>
    </div>
</div>



<!-- 
<div matColumnDef="{{item.name}}" *ngIf="item.name == 'actions'">
    <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3 td-align-center">
        <button mat-icon-button matTooltip="Editar">
            <mat-icon>create</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Agregar producto">
            <mat-icon>add_shopping_cart</mat-icon>
        </button>
        <button mat-icon-button [matTooltip]="element.estado==true ? 'Desactivar': 'Activar'">
            <mat-icon>{{element.estado==true? 'toggle_on' : 'toggle_off' }}</mat-icon>
        </button>
    </td>
</div> -->